import { Component, input, output } from '@angular/core';
import {
  GcAccordionComponent,
  GcButtonComponent,
  GcCheckboxComponent,
  GcDatePickerComponent,
  GcFilechooserComponent,
  GcInputFieldComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { InstallationReportSectionConfig } from '../../model/installation-reporting-mdu-section.types';
import { SectionState } from '../../state/installation-reporting-mdu-section-state.types';

@Component({
  selector: 'app-section-sidebar',
  imports: [
    GcDatePickerComponent,
    GcInputFieldComponent,
    GcAccordionComponent,
    GcCheckboxComponent,
    GcFilechooserComponent,
    GcButtonComponent,
    GcTextComponent,
    IpoTranslatePipe,
  ],
  templateUrl: './section-sidebar.component.html',
  styleUrl: './section-sidebar.component.scss',
})
export class SectionSidebarComponent {
  readonly dateFormat = 'sv' as const;

  config = input.required<InstallationReportSectionConfig>();
  sectionState = input.required<SectionState>();
  canMarkNotApplicable = input(false);

  plannedDateChanged = output<Date | undefined>();
  completedDateChanged = output<Date | undefined>();
  commentChanged = output<string>();
  checklistChanged = output<{ field: string; checked: boolean }>();
  filesChanged = output<File[]>();
  markNotApplicableClicked = output<void>();
}
